import React from 'react';

interface ForgotPasswordFormProps {
	forgotEmail: string;
	setForgotEmail: (email: string) => void;
	loading: boolean;
	successMessage: string;
	onSubmit: (e: React.FormEvent) => void;
	onBackToLogin: () => void;
}

const ForgotPasswordForm: React.FC<ForgotPasswordFormProps> = ({
	forgotEmail,
	setForgotEmail,
	loading,
	successMessage,
	onSubmit,
	onBackToLogin,
}) => {
	return (
		<form className="space-y-6" onSubmit={onSubmit}>
			{successMessage && (
				<div className="rounded-md bg-green-50 p-4">
					<div className="flex">
						<div className="ml-3">
							<h3 className="text-sm font-medium text-green-800">
								{successMessage}
							</h3>
						</div>
					</div>
				</div>
			)}

			{!successMessage ? (
				<>
					<div>
						<label
							htmlFor="forgot-email"
							className="block text-sm font-medium text-gray-700"
						>
							Enter your email
						</label>
						<div className="mt-1">
							<input
								id="forgot-email"
								name="forgot-email"
								type="email"
								autoComplete="email"
								required
								value={forgotEmail}
								onChange={(e) => setForgotEmail(e.target.value)}
								className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:ring-purple-500 focus:border-purple-500 sm:text-sm"
								placeholder="Enter your email"
							/>
						</div>
					</div>
					<div className="flex items-center justify-between">
						<button
							type="submit"
							disabled={loading}
							className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-purple-600 hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500 disabled:opacity-50 disabled:cursor-not-allowed"
						>
							{loading ? 'Sending reset link...' : 'Send reset link'}
						</button>
					</div>
					<div className="mt-2 text-center">
						<button
							type="button"
							className="text-sm text-gray-600 hover:text-gray-800"
							onClick={onBackToLogin}
						>
							Back to sign in
						</button>
					</div>
				</>
			) : (
				<div className="mt-2 text-center">
					<button
						type="button"
						className="text-sm text-gray-600 hover:text-gray-800"
						onClick={onBackToLogin}
					>
						Back to sign in
					</button>
				</div>
			)}
		</form>
	);
};

export default ForgotPasswordForm;
